export const TAGS_OPEN_CLOSE_DELETE_TAGS_MODAL = "TAGS_OPEN_CLOSE_DELETE_TAGS_MODAL";

export const TAGS_DELETE_TAGS = "TAGS_DELETE_TAGS";
export const TAGS_DELETE_TAGS_RESPONSE = "TAGS_DELETE_TAGS_RESPONSE";